import { EyeOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, Modal, Row, Table } from "antd";
import TextArea from "antd/es/input/TextArea";
import { ColumnsType } from "antd/es/table";
import React from "react";
interface props {
  onCancel: any;
  isModelOpen: boolean;
}
const BidRecivedModal = ({ onCancel, isModelOpen }: props) => {
  const dataSource = [
    {
      key: "1",
      bidName: "Mike",
      age: 32,
      address: "10 Downing Street",
    },
  ];

  const columns: ColumnsType<any> = [
    {
      title: "Bid Id",
      dataIndex: "bidId",
      key: "bidId",
    },

    {
      title: "Bid Name",
      dataIndex: "bidName",
      key: "bidName",
    },
    {
      title: "Bid Start Date",
      dataIndex: "bidStartDate",
      key: "bidStartDate",
    },
    {
      title: "Bid End Date",
      dataIndex: "bidEndDate",
      key: "bidEndDate",
    },
    {
      title: "Bid Applied",
      dataIndex: "bidApplied",
      key: "bidApplied",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
  ];
  return (
    <>
      <Modal
        width={1500}
        open={isModelOpen}
        footer={
          <>
            <Row gutter={10}>
              <Col>
                <Button type="primary">Accept Bid</Button>
              </Col>
              <Col>
                <Button onClick={() => onCancel(false)}>Cancel</Button>
              </Col>
            </Row>
          </>
        }
      >
        <Card size="small" type="inner">
          <Table
            columns={columns}
            dataSource={dataSource}
            style={{ marginTop: "10px" }}
            pagination={false}
          />
        </Card>
        <Card
          type="inner"
          size="small"
          title="Documents Check Box"
          style={{ margin: "15px 0px" }}
        >
          <Row justify={"space-between"} style={{ margin: "30px 0px" }}>
            <Col>GST</Col>
            <Col>
              <Button size="small">
                <EyeOutlined />
              </Button>
            </Col>
          </Row>

          <Row justify={"space-between"} style={{ margin: "30px 0px" }}>
            <Col>ISO Certificate </Col>
            <Col>
              <Button size="small">
                <EyeOutlined />
              </Button>
            </Col>
          </Row>
        </Card>

        <Card type="inner" size="small" title="Other Comments">
          <Form layout="vertical">
            <Form.Item label="comment">
              <TextArea rows={2} />
            </Form.Item>
          </Form>
        </Card>
      </Modal>
    </>
  );
};

export default BidRecivedModal;
